import React, { Children, useState, useEffect } from "react";
import Layout from "../components/layout";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Container,
  Collapse,
  Typography,
  List,
  ListItem,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import moment from "moment";
import { useCookies } from "react-cookie";
// import "react-big-calendar/lib/css/react-big-calendar.css";
import "./css/calendar.css";
import { theme } from "../components/theme";
import { graphql, navigate } from "gatsby";
import BackgroundImage from "gatsby-background-image";
import Img from "gatsby-image";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { AnchorLink } from "gatsby-plugin-anchor-links";
import FilterHdrOutlinedIcon from "@material-ui/icons/FilterHdrOutlined";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import _ from "lodash";
import { add_to_cart } from "../utils/cart";
import { sub } from "date-fns";

// Setup the localizer by providing the moment (or globalize) Object
// to the correct localizer.
const localizer = momentLocalizer(moment); // or globalizeLocalizer
const CURRENT_DATE = moment().toDate();

const useStyles = makeStyles((theme) => ({
  eventDialog: {
    width: "100vw",
  },
  eventDialogContent: {
    width: "100%",
  },
  bgHero: {
    height: 400,
    width: "100%",
    display: "flex",
  },
  hero: {
    height: 400,
  },
  heroContent: {
    height: 400,
  },
  listItem: {
    background: "rgb(255,255,255)",
    border: "1px solid rgb(240,240,240)",
    borderRight: "0px",
    borderLeft: "0px",
    borderTop: "0px",
    display: "flex",
    justifyContent: "space-between",
    fontSize: "18px",
  },
  listItemSub: {
    background: "rgb(255,255,255)",
    paddingLeft: "2%",
    paddingTop: 20,
    paddingBottom: 20,
    border: "1px solid rgb(240,240,240)",
    borderRight: "0px",
    borderLeft: "0px",
    borderTop: "0px",
  },
  listContainer: {
    width: "100%",
  },
  dotPoints: {
    fontSize: "1rem",
    fontWeight: 400,
    [theme.breakpoints.down("sm")]: {
      listStyle: "none",
      "& li::before": {
        content: '"- "',
      },
      marginLeft: "0px !important",
    },
  },
}));

function getNewRandomColor() {
  var myArray = [
    "rgb(244, 193, 193)",
    "rgb(244, 193, 193)",
    "rgb(244, 193, 193)",
  ];
  var rand = myArray[Math.floor(Math.random() * myArray.length)];
  return rand;
}
const ColoredDateCellWrapper = ({ children, value }) =>
  React.cloneElement(Children.only(children), {
    style: {
      ...children.style,
    },
  });

const FitnessHikes = ({ data }) => {
  const [addingToCart, setAddingToCart] = useState(false);
  const [cookies, setCookie] = useCookies(["tsa_cart"]);
  const [events, setEvents] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState({});
  const [cart, setCart] = useState([]);
  const mdDown = useMediaQuery("(max-width:1000px)");
  const calendarMobile = useMediaQuery("(max-width:700px)");
  const classes = useStyles();
  const [faqOpen, setFaqOpen] = useState([]);

  console.log(data);

  const faqs = [
    {
      q: "What happens on a hike?",
      a:
        "We start off with a stretch and some strength work to open hips and get the legs, heart and head moving. We then take a hike along some favourite tracks. We might throw in various games and cardio drills to make sure you get the most out of the hike if it's a short track, otherwise we'll do a short loop or circuit that involves a range of terrain and is sure to include some hills. If we’ve got time, we’ll finish with some core exercises and stretches.",
    },
    {
      q: "Am I fit enough",
      a:
        "If we had a dollar for every time we get asked this! The answer is yes! These hikes are a walk in the park still, however we’ve just added some steeper terrain and some challenges which makes the hike variable. It means you can be less or more fit, and you’ll get a great morning out. They are suitable for our grade 3,4,5 hikers. See our grading page.",
    },
    {
      q: "Regular ‘other’ hike training",
      a:
        "We also have themed weeks where your guide and trainers will teach you more about a particular product, skill or challenge such as using hiking poles, cooking on gas, packing your backpack, choosing the right shoes. Our guides have a wealth of knowledge so keep an eye out for the special walks.",
    },
    {
      q: "Are they fun and social?",
      a:
        "Absolutely! These walks are designed to be the best morning out. Come by yourself or with friends and chat with other like minded people that you already know or meet new people who want to be walking with you! Our awesome adventure guides, PT’s, Coaches and Nutritionist are also there to support you as well. Everyone wants to achieve something so come along and share your story. We promise there will be lots of high 5’s and laughter.",
    },
    {
      q: "How do I book?",
      a:
        "Choose any of the Fitness Hike from our calendar and book in. You’ll get an email follow up with details, location link and any further information you may need to attend. You can purchase multi-packs or use a voucher!",
    },
    {
      q: "Where are they located?",
      a:
        "Our fitness hikes are not your usual '1000 steps' locations. They are a little out of the way but still easy to find and mostly within an hour of Melbourne. Located all around so you can stick to your side of town or explore pars and forests further afield when you want.",
    },
    {
      q: "Toilets?",
      a:
        "Always an important factor before heading off on a walk!. We have planned these locations to either have toilets at the start or at least nearby. Each location has details on this.",
    },
  ];

  useEffect(() => {
    let newFaqOpen = [];
    faqs.forEach((faq, index) => {
      newFaqOpen = [...newFaqOpen, false];
    });
    setFaqOpen(newFaqOpen);
    const curEvents = data.allWpProduct.edges;
    let formatedEvents = [...events];
    curEvents.forEach((event) => {
      const start = moment(
        event.node.acfFields.eventStart,
        "DD/MM/YYYY"
      ).toDate(); // 1st argument - string, 2nd argument - format
      const end = moment(event.node.acfFields.eventEnd, "DD/MM/YYYY").toDate();
      formatedEvents = [
        ...formatedEvents,
        {
          eventStart: start,
          eventEnd: end,
          product_id: event.node.product_id,
          title: event.node.title.replace("Fitness Hike – ", ""),
          locationName: event.node.locations.nodes[0].name,
          meetingAddress: event.node.locations.nodes[0].name,
          price: event.node.price,
          description: event.node.content,
          productType: "Fitness Hike",
        },
      ];
    });

    setEvents(formatedEvents);
  }, []);

  const handleSelect = (e) => {
    const title = window.prompt("New Event name");
    const start = e.start;
    const end = e.end;
    if (title)
      setEvents([
        ...events,
        {
          eventStart: start,
          eventEnd: end,
          title: title,
          product_id: e.product_id,
          locationName: e.locationName,
          meetingAddress: e.meetingAddress,
          price: e.price,
          description: e.description,
          productType: "Fitness Hike",
        },
      ]);
  };

  const viewEvent = (e) => {
    setOpen(true);
    setSelectedEvent(e);
  };

  const closeEvent = () => {
    setOpen(false);
  };

  const bookNow = (event) => {
    console.log(event);
    add_to_cart(event.product_id, 1, cookies.tsa_cart);
    setAddingToCart(true);
    setTimeout(() => {
      navigate(`/cart`);
      setAddingToCart(false);
    }, 2000);
  };
  const addToCart = (event) => {
    setAddingToCart(true);
    add_to_cart(event.product_id, 1, cookies.tsa_cart).then(() => {
      setAddingToCart(false);
      setOpen(false);
    });
  };

  const bookBulk = () => {
    console.log(cart);
  };

  const AgendaEvent = ({ event }) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          height: "155px",
          width: "100%",
          cursor: "pointer",
        }}
        onClick={() => viewEvent(event)}
      >
        <div style={{ fontWeight: 600 }}>{event.title}</div>
        <div style={{ textDecoration: "underline" }}>View hike</div>
      </div>
    );
  };

  const EventContainer = ({ event }) => {
    if (calendarMobile) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "row",
            alignItems: "center",
            height: "calc(400px / 6)",
            width: "100%",
            textAlign: "center",
            backgroundColor: getNewRandomColor(),
          }}
        >
          <FilterHdrOutlinedIcon style={{ fontSize: 24 }} align="center" />
        </div>
      );
    } else {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            height: "155px",
            width: "100%",
            backgroundColor: getNewRandomColor(),
          }}
        >
          <div style={{ fontWeight: 600 }}>{event.title}</div>
          <div style={{ textDecoration: "underline" }}>View hike</div>
        </div>
      );
    }
  };

  const handleFaqOpen = (index) => {
    const newFaqs = [...faqOpen];
    newFaqs[index] = !faqOpen[index];
    setFaqOpen(newFaqs);
  };

  const bundleCheckout = (id) => {
    const product = data.allWpProduct.nodes.filter(
      (product) => product.product_id === id
    );
    console.log(product);
    setAddingToCart(true);
    add_to_cart(product[0].product_id, 1, cookies.tsa_cart);
    setTimeout(() => {
      navigate(`/cart`);
      setAddingToCart(false);
    }, 2000);
  };

  const handleCartRemove = (event) => {
    let newCart = cart.filter((curEvent) => curEvent.title !== event.title);
    setCart(newCart);
  };

  return (
    <Layout>
      <Grid container alignItems="center" className={classes.hero}>
        <BackgroundImage
          fluid={data.hero.childImageSharp.fluid}
          className={classes.bgHero}
          Tag="section"
          backgroundColor={`#040e18`}
        >
          <Grid
            container
            className={classes.heroContent}
            alignContent="center"
            alignItems="center"
            justify="center"
          >
            <Grid item xs={12} align="center">
              <Typography
                variant={"h1"}
                style={{ color: "white", textTransform: "uppercase" }}
              >
                Fitness Hikes
              </Typography>
            </Grid>
            <Grid
              item
              container
              xs={12}
              align="center"
              justify="center"
              style={{ marginTop: 10 }}
            >
              <AnchorLink to="/fitness-hikes#calendar">
                <Button
                  style={{
                    color: "white",
                    border: "1px solid #fff",
                    borderRadius: 8,
                  }}
                >
                  View Fitness Hiking Calendar
                </Button>
              </AnchorLink>
            </Grid>
          </Grid>
        </BackgroundImage>
      </Grid>
      <Container>
        <Grid
          container
          justify="space-around"
          alignItems="center"
          style={{ marginTop: 80 }}
        >
          {mdDown && (
            <Grid
              item
              xs={12}
              md={5}
              style={{ marginBottom: 40 }}
              align="center"
            >
              <Img
                fluid={data.hikingDoodle.childImageSharp.fluid}
                style={{ height: "100%", width: "100%", maxWidth: 400 }}
              />
            </Grid>
          )}
          <Grid item xs={12} md={5} align={mdDown ? "center" : "left"}>
            <Typography variant="h2" style={{ marginBottom: 20 }}>
              Half Day Fitness Hikes
            </Typography>
            <Typography variant="body1">
              Take Shape Adventures is proud to launch a new opportunity for
              you. Our Half-day Fitness Hikes, every Saturday and Sunday are a
              great way to catch up with fellow hiking and fitness buddies, plan
              and train for your next big adventure and have our qualified
              guides and personal trainers assist you to reach your goals.
            </Typography>
            <Typography variant="body1" style={{ marginTop: 20 }}>
              Half-day fitness hikes are:
            </Typography>

            <ul
              style={{ marginLeft: 50, marginTop: 10 }}
              className={classes.dotPoints}
            >
              <li>Within 1 hr of Melbourne</li>
              <li>3hrs for a perfect morning escape.</li>
              <li>Suitable for Grade 3, 4 and 5</li>
              <li>
                Fitness Snacks provided Fully supported by professional staff.
              </li>
              <li> And most of all they are FUN and SOCIAL!</li>
            </ul>
            <AnchorLink to="/fitness-hikes#qa">
              <Typography
                variant="body1"
                style={{ marginTop: 20, textDecoration: "underline" }}
              >
                What do I bring? Am I fit enough? Your questions answered
                here...
              </Typography>
            </AnchorLink>
          </Grid>
          {!mdDown && (
            <Grid item xs={12} md={5}>
              <Img
                fluid={data.hikingDoodle.childImageSharp.fluid}
                style={{ height: "100%", width: "100%" }}
              />
            </Grid>
          )}
        </Grid>
        <Grid
          container
          justify="space-around"
          alignItems="center"
          style={{ marginTop: 140 }}
          align={mdDown ? "center" : "left"}
        >
          <Grid item xs={6} md={3} align="center">
            <Img
              fluid={data.backpackDoodle.childImageSharp.fluid}
              style={{ height: "100%", width: "100%", maxWidth: 300 }}
            />
          </Grid>
          <Grid
            item
            container
            xs={12}
            md={6}
            style={mdDown ? { marginTop: 30 } : { marginTop: 0 }}
          >
            <Grid item xs={12}>
              <Typography variant="h2" style={{ marginBottom: 20 }}>
                How to join us
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1">
                Don’t sit on the side lines wishing to participate in amazing
                adventures. And there is no need to trudge up hills on your own.
                Our fitness hikes are the perfect opportunity to get out, to
                meet other people and feel supported by not only our amazing
                team but by your community of like minded friends.
              </Typography>
            </Grid>
            <Grid
              item
              container
              xs={12}
              style={{ marginTop: 30 }}
              align={mdDown ? "center" : "left"}
              justify="space-between"
            >
              {!addingToCart ? (
                <>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    style={mdDown ? { marginBottom: 30 } : { marginBottom: 0 }}
                  >
                    <Typography variant="body1" style={{ fontWeight: 600 }}>
                      Casual Rate
                    </Typography>
                    <Typography variant="body1">
                      $45 - single session
                    </Typography>
                    <AnchorLink to="/fitness-hikes#calendar">
                      <Typography
                        variant="button"
                        color="primary"
                        style={{ marginTop: 10, cursor: "pointer" }}
                      >
                        Book Now
                      </Typography>
                    </AnchorLink>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    style={mdDown ? { marginBottom: 30 } : { marginBottom: 0 }}
                  >
                    <Typography variant="body1" style={{ fontWeight: 600 }}>
                      5x Fitness Hike Bundle
                    </Typography>
                    <Typography variant="body1">$199 - Save $26.00</Typography>
                    <Typography
                      variant="button"
                      color="primary"
                      style={{ marginTop: 10, cursor: "pointer" }}
                      onClick={() => bundleCheckout("814")}
                    >
                      Buy Now
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    style={mdDown ? { marginBottom: 30 } : { marginBottom: 0 }}
                  >
                    <Typography variant="body1" style={{ fontWeight: 600 }}>
                      10x Fitness Hike Bundle
                    </Typography>
                    <Typography variant="body1">$379 - Save $71.00</Typography>
                    <Typography variant="body1">PLUS a free Buff</Typography>
                    <Typography
                      variant="button"
                      color="primary"
                      style={{ marginTop: 10, cursor: "pointer" }}
                      onClick={() => bundleCheckout("818")}
                    >
                      Buy Now
                    </Typography>
                  </Grid>
                </>
              ) : (
                <Typography>Adding to cart...</Typography>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Typography
          variant="h2"
          align="center"
          style={{ marginTop: 140, marginBottom: 10 }}
          id="calendar"
        >
          Fitness Hike Calendar
        </Typography>
        <Typography variant="h4" align="center">
          Book into your next fitness hike
        </Typography>
        <Typography variant="body2" align="center" style={{ marginTop: 10 }}>
          Select one of the highlighted events below and add to cart or book
          right away!
        </Typography>
        <Grid container style={{ marginTop: 40, marginBottom: 20 }}>
          <Grid item xs={12} md={12}>
            <div
              style={{
                height: "100%",
                borderRadius: 8,
                padding: 20,
                boxShadow: "0 3px 8px 2px rgba(0,0,0,0.1)",
              }}
            >
              <Calendar
                selectable
                events={events}
                startAccessor="eventStart"
                endAccessor="eventEnd"
                views={["month", "agenda"]}
                defaultView={mdDown ? Views.AGENDA : Views.MONTH}
                components={{
                  dateCellWrapper: ColoredDateCellWrapper,
                  event: EventContainer,
                  agenda: {
                    event: AgendaEvent, // with the agenda view use a different component to render events
                  },
                }}
                // onSelectSlot={e => handleSelect(e)}
                onSelectEvent={(e) => viewEvent(e)}
                localizer={localizer}
              />
            </div>
          </Grid>
        </Grid>
        <Grid
          container
          justify="center"
          alignItems="center"
          align="center"
          style={{ marginTop: 80, marginBottom: 80 }}
          id="qa"
        >
          <Grid item xs={12} md={9}>
            <Typography variant="h2" style={{ marginBottom: 20 }}>
              Frequently Asked Questions
            </Typography>
            <List>
              {faqs.map((qna, index) => {
                return (
                  <div key={qna.q}>
                    <ListItem
                      onClick={() => handleFaqOpen(index)}
                      style={{
                        background: "rgb(255,255,255)",
                        border: "1px solid rgb(240,240,240)",
                        borderRight: "0px",
                        borderLeft: "0px",
                        borderTop: "0px",
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "18px",
                      }}
                    >
                      {qna.q}
                      {faqOpen[index] ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>
                    <Collapse in={faqOpen[index]} timeout="auto" unmountOnExit>
                      <ListItem
                        button
                        style={{
                          background: "rgb(255,255,255)",
                          paddingLeft: "2%",
                          paddingTop: 20,
                          paddingBottom: 20,
                          border: "1px solid rgb(240,240,240)",
                          borderRight: "0px",
                          borderLeft: "0px",
                          borderTop: "0px",
                        }}
                      >
                        {qna.a}
                      </ListItem>
                    </Collapse>
                  </div>
                );
              })}
            </List>
          </Grid>
        </Grid>
        <Dialog
          open={open}
          onClose={closeEvent}
          keepMounted
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          className={classes.eventDialog}
        >
          <DialogTitle color="textPrimary" id="alert-dialog-slide-title">
            {selectedEvent.title}
          </DialogTitle>
          <DialogContent className={classes.eventDialogContent}>
            <DialogContentText
              color="textPrimary"
              id="alert-dialog-slide-description"
            >
              <strong>Price:</strong> ${selectedEvent.price + ".00"}
            </DialogContentText>
            <DialogContentText
              color="textPrimary"
              id="alert-dialog-slide-description"
            >
              <strong>Start:</strong>{" "}
              {moment(selectedEvent.eventStart).format("MMMM DD - h:mm a")}
            </DialogContentText>
            <DialogContentText
              color="textPrimary"
              id="alert-dialog-slide-description"
            >
              <strong>End:</strong>{" "}
              {moment(selectedEvent.eventEnd).format("MMMM DD - h:mm a")}
            </DialogContentText>
            <DialogContentText
              color="textPrimary"
              id="alert-dialog-slide-description"
            >
              <strong>Where:</strong> {selectedEvent.locationName}
            </DialogContentText>
            <DialogContentText
              color="textPrimary"
              id="alert-dialog-slide-description"
            >
              <strong>Meeting Point:</strong>{" "}
              {selectedEvent.meetingAddress || "Will be notified via email"}
            </DialogContentText>
            <DialogContentText
              color="textPrimary"
              id="alert-dialog-slide-description"
            >
              <strong>Hike Overview:</strong> {selectedEvent.description}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={closeEvent} color="primary">
              Close
            </Button>
            <Button onClick={() => addToCart(selectedEvent)} color="primary">
              Add to cart
            </Button>
            <Button onClick={() => bookNow(selectedEvent)} color="primary">
              Book Now
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Layout>
  );
};

export const query = graphql`
  query FitnessHikesQuery {
    products: allWpProduct(limit: 10) {
      edges {
        node {
          acfFields {
            accommodation
            brochure
            days
            distance
            equipment
            eventEnd
            eventStart
            experiences
            featured
            fieldGroupName
            food
            formId
            grade
            highlights
            itinerary
            tourguides
            transport
            imageone {
              altText
              localFile {
                childImageSharp {
                  fluid {
                    ...GatsbyImageSharpFluid_withWebp_tracedSVG
                  }
                }
              }
              sourceUrl
            }
            imagethree {
              altText
              localFile {
                childImageSharp {
                  fluid {
                    ...GatsbyImageSharpFluid_withWebp_tracedSVG
                  }
                }
              }
              sourceUrl
            }
            imagetwo {
              altText
              localFile {
                childImageSharp {
                  fluid {
                    ...GatsbyImageSharpFluid_withWebp_tracedSVG
                  }
                }
              }
              sourceUrl
            }
          }
          featuredImage {
            node {
              sourceUrl
              localFile {
                childImageSharp {
                  fluid {
                    ...GatsbyImageSharpFluid_withWebp_tracedSVG
                  }
                }
              }
            }
          }
          title
          uri
          slug
          product_id
          price
          id
          productCategories {
            nodes {
              name
            }
          }
          locations {
            nodes {
              name
              slug
            }
          }
          countries {
            nodes {
              name
              acfFields {
                featuredImage {
                  sourceUrl
                  localFile {
                    childImageSharp {
                      fluid {
                        ...GatsbyImageSharpFluid_withWebp_tracedSVG
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    hero: file(relativePath: { eq: "hero/hero-mountain.jpg" }) {
      childImageSharp {
        fluid(quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_tracedSVG
        }
      }
    }
    hikingDoodle: file(
      relativePath: { eq: "fitness-hikes/fitness-hike-mountain.jpg" }
    ) {
      childImageSharp {
        fluid(quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_tracedSVG
        }
      }
    }
    backpackDoodle: file(
      relativePath: { eq: "fitness-hikes/fitness-hike-training.jpg" }
    ) {
      childImageSharp {
        fluid(quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_tracedSVG
        }
      }
    }
  }
`;

export default FitnessHikes;
